// extracted by LIB_CSS_EXTRACT_LOADER
import "./hover-card_module.css"
export default {"positioner":"positioner-yGweDz","popup":"popup-ve3G3g"};